import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "@arco-design/web-react";
import Header from "@/layouts/components/Header";
import Menu from "@/layouts/components/Menu";
import HomeLogin from "@/pages/HomeLogin";
import userStore from "@/stores/user";
import teamStore from "@/stores/team";

import styles from "./index.module.less";

const Content = Layout.Content;

const BasicLayout = () => {
  // 根据用户获取套餐信息
  useEffect(() => {
    teamStore.getPackageInfo();
    userStore.getUserInfo();
  }, [userStore?.userInfo?.id]);

  return (
    <div className={styles.basice_layout_box}>
      <Header />
      <Layout>
        <div className={styles.layout_content}>
          <div className={styles.layout_sider}>
            <Menu />
          </div>
          <Content className={styles.content_box}>
            <Outlet />
          </Content>
        </div>
      </Layout>
      <HomeLogin />
    </div>
  );
};

export default BasicLayout;
